<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.newsname" placeholder="资讯名称/关键字/作者"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.beginDate"
            :editable="false"
            type="date"
            placeholder="发布开始日期">
          </el-date-picker>
          <el-date-picker
            v-model="filters.endDate"
            :editable="false"
            type="date"
            placeholder="发布截至日期">
          </el-date-picker>
          <el-select v-model="filters.pubstate" placeholder="发布状态" >
            <el-option label="未发布"  value="1"></el-option>
            <el-option label="已发布"  value="0"></el-option>
            <el-option label="已删除"  value="2"></el-option>
            <el-option label="草稿"  value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.consultId" placeholder="资讯分类" >
            <el-option
              v-for="item in addForm.consultReturn"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.projectId" placeholder="项目分类">
            <el-option
              v-for="item in projtypess"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.newsTypeId" placeholder="文章类型" >
            <el-option
              v-for="item in addForm.newsTypeReturn"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="filters.sub1" placeholder="学科分类一级" @change="getDictSubject2()">
            <el-option
              v-for="item in addForm.sId1Return"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="filters.sub2" placeholder="学科分类二级" >
            <el-option
              v-for="item in addForm.sId2Return"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" v-on:click="getNews">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="buttonsAccess.indexOf('新增') > -1" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="news" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border>
      <el-table-column prop="id" label="id" width="100">
      </el-table-column>
      <el-table-column prop="newsTitle" label="标题" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="publishMan" label="发布人" width="120" >
      </el-table-column>
      <el-table-column prop="displayPosition" label="显示位置" width="105" >
      </el-table-column>
      <el-table-column prop="publishState" label="发布状态" min-width="95" :formatter="formatpstate" >
      </el-table-column>
      <el-table-column prop="publishTime" label="发布时间" min-width="180" >
      </el-table-column>
      <el-table-column prop="webReadCount" label="浏览总量" min-width="100" >
      </el-table-column>
      <el-table-column prop="webReadCount" label="网页浏览量" min-width="120" >
      </el-table-column>
      <el-table-column prop="appReadCount" label="APP浏览量" min-width="120" >
      </el-table-column>
      <el-table-column prop="creator" label="创建者" min-width="120" >
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="180" >
      </el-table-column>
      <el-table-column prop="motifyor" label="修改者" min-width="120" >
      </el-table-column>
      <el-table-column prop="motifyTime" label="修改时间" min-width="180" >
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="cancelPublish(scope.$index, scope.row)"   v-if="buttonsAccess.indexOf('发布状态') > -1 && scope.row.publishState ==0">取消发布</el-button>
          <el-button size="small" @click="publisNew(scope.$index, scope.row)"  v-if="buttonsAccess.indexOf('发布状态') > -1 && scope.row.publishState ==1">发布</el-button>
          <el-button size="small" @click="publisNew(scope.$index, scope.row)"  v-if="buttonsAccess.indexOf('发布状态') > -1 &&scope.row.publishState ==3">发布</el-button>
          <el-button size="small" @click="viewNews(scope.$index, scope.row)" v-if="buttonsAccess.indexOf('预览') > -1" >预览</el-button>
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="buttonsAccess.indexOf('编辑') > -1" >编辑</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="buttonsAccess.indexOf('删除') > -1" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :current-page="currentPage">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog :title="addFormTtile" :visible.sync="addFormVisible" :close-on-click-modal="false" width="100%" top="0">
      <el-form :model="addForm" label-width="80px" ref="addForm" :rules="addFormRules" >
        <el-form-item label="资讯分类" prop="consultId" label-width="100px">
          <el-select v-model="addForm.consultId" filterable no-match-text="无匹配数据"  placeholder="请选择资讯分类" style="width: 435px">
            <el-option
              v-for="item in addForm.consultReturn"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
          <el-row>
            <el-select v-show="addForm.consultId==24" v-model="addForm.secondLoginId" multiple  :multiple-limit=parseInt(5)  placeholder="请选择二级页面" style="width: 435px" >
              <el-option
                collapse-tags
                v-for="item in addForm.secondLoginOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <el-button type="text" style="color:red">贵州基层大练兵：政策文件-->通知公告 ; 工作动态-->培训动态</el-button>
          </el-row>
        </el-form-item>
        <el-form-item label="学科分类" label-width="100px">
          <el-select v-model="addForm.sId1" placeholder="请选择学科分类" filterable  no-match-text="无匹配数据" @change="getDictSubject2()">
            <el-option
              v-for="item in addForm.sId1Return"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
          <el-select v-model="addForm.sId2" placeholder="请选择学科分类">
            <el-option
              v-for="item in addForm.sId2Return"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-plus"   @click.native="addSubject" ></el-button><br/>
        </el-form-item>
        <el-form-item >
          <el-tag
            v-for="tag in addForm.subjectArray"
            @close="removeSubject(tag)"
            :closable="true"
            type="primary"
            :key="tag.key">
            {{tag.value}}
          </el-tag>
        </el-form-item>
        <el-form-item label="项目分类" label-width="100px">
          <el-checkbox :indeterminate="addForm.isIndeterminate" v-model="addForm.checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="addForm.project" @change="handleCheckedCitiesChange">
            <el-checkbox  v-for="item in projtypess" :label="item.id" :key="item.id" >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="标题" prop="newsTitle" label-width="100px">
           <el-input v-model="addForm.newsTitle" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="文章类型" label-width="100px">
          <el-select v-model="addForm.newsTypeId" placeholder="请选择文章分类">
            <el-option
              v-for="item in addForm.newsTypeReturn"
              :label="item.name"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作者" label-width="100px">
          <!-- <el-input v-model="addForm.author" auto-complete="off"></el-input> -->
          <el-select
            v-model="addForm.authorId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入作者姓名搜索"
            :remote-method="remoteMethod"
            :loading="selectLoading"
            style="width: 100%"
            popper-class="custom_select"
          >
            <el-option
              v-for="(item, index) in selectOptions"
              :key="index"
              :label="item.doctorName"
              :value="item.doctorId"
            >
            <div class="custom_content">
              <p style="margin: 0">{{item.doctorName}}</p>
              <p style="margin: 0"><span>医院：</span>{{item.companyName}}</p>
              <p style="margin: 0"><span>科室：</span>{{item.departmentName}}</p>
            </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="编辑" label-width="100px">
          <el-input v-model="addForm.editor" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="newsSource" label-width="100px">
          <el-input v-model="addForm.newsSource" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发布日期" label-width="100px">
          <el-date-picker
            v-model="addForm.publishTime"
            type="datetime"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键词" prop="keywords" label-width="100px">
          <el-input type="textarea" v-model="addForm.keywords" placeholder="(控制在5个以内，每个关键词 不超过8个字符，中间用英文“,”间隔)"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description" label-width="100px">
          <el-input type="textarea" v-model="addForm.description" placeholder="(限200字以内)"></el-input>
        </el-form-item>

        <el-form-item label="图片" label-width="100px" prop="imgUrl" v-model="addForm.imgUrl">
          <el-upload
            :action="uploadUrl"
            :before-upload="uploadBefore"
            :on-success="handleSuccess"
            :file-list="addForm.fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">图片支持jpg格式，大小300*400</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="权重" label-width="100px">
          <el-input-number v-model="addForm.weight"></el-input-number>
        </el-form-item>
        <el-form-item label="显示位置" label-width="100px">
          <el-radio-group v-model="addForm.displayPosition">
            <el-radio class="radio" label="1">web</el-radio>
            <el-radio class="radio" label="2">app</el-radio>
            <el-radio class="radio" label="3">全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="最新显示" label-width="100px">
          <el-radio-group v-model="addForm.isNew">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="声明" label-width="100px">
          <el-radio-group v-model="addForm.declareType">
            <el-radio class="radio" label="1">学术会议</el-radio>
            <el-radio class="radio" label="2">其他类型</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="资讯内容" label-width="100px">
          <ckeditor v-model="addForm.content"
                    extraplugins="lineheight,uploadimage,jsplus_easy_file,jsplus_easy_image,insertmedia"
                    :id="ckeditorConfig.editor"
                    :font_names="ckeditorConfig.font_names"
                    :toolbar="ckeditorConfig.toolbar"
                    :language="ckeditorConfig.language"
                    :height="ckeditorConfig.height"
                    :filebrowserUploadUrl="ckUploadUrl" :jsplusUploaderUrl="jplusUpload"></ckeditor>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit(3)" :loading="addLoading">保存草稿</el-button>
        <el-button type="primary" @click.native="addSubmit(1)" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import Ckeditor from '../../component/ckeditor.vue'
  import { getNewsListPage,getConsultList,getDictNewsType,getDictSubject, addNewsInfo, delNewsInfo, validateNewsTitle, editNewsInfo ,getSecondLoginPosition, doctorSearchDoctor} from '../../api/api';
  export default {
    components: {
      Ckeditor
    },
    data() {
      var validateNITitle = (rule, value, callback) => {
        if(value!=''){
          if (this.addForm.id == 0 || (this.addForm.id != 0 && this.addForm.oldName != this.addForm.newsTitle)) {
            const formData = new FormData();
            formData.append('name', value);
            validateNewsTitle(formData).then(function (response) {
              if (!response.data.status) {
                callback(new Error('资讯名称重复'));
              } else {
                callback();
              }
            })
          }else {
            callback();
          }
        }else{
          callback(new Error('请填写资讯名称'));
        }
      };
      return {
        ckeditorConfig: {
          id:'editor',
          font_names:'宋体/SimSun;新宋体/NSimSun;仿宋/FangSong;楷体/KaiTi;仿宋_GB2312/FangSong_GB2312;楷体_GB2312/KaiTi_GB2312;黑体/SimHei;华文细黑/STXihei;华文楷体/STKaiti;华文宋体/STSong;华文中宋/STZhongsong;华文仿宋/STFangsong;华文彩云/STCaiyun;华文琥珀/STHupo;华文隶书/STLiti;华文行楷/STXingkai;华文新魏/STXinwei;方正舒体/FZShuTi;方正姚体/FZYaoti;细明体/MingLiU;新细明体/PMingLiU;微软雅黑/Microsoft YaHei;微软正黑/Microsoft JhengHei;Arial Black/Arial Black;',
          language:'zh-cn',
          toolbar:[
            { name: 'document', items: [ 'Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates' ] },
            { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', 'Undo', 'Redo' ] },
            { name: 'editing', items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
            { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
            '/',
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ] },
            { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
            { name: 'insert', items: [ 'Image', 'Flash','jsplus_easy_file','jsplus_easy_image' ,'insertmedia', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },
            '/',
            { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' , 'lineheight'] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'tools', items: [ 'Maximize', 'ShowBlocks'] },
            { name: 'about', items: [ 'About'] }
          ],
          height:'300px'
        },
        buttonsAccess:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[101108]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[101108].buttons:[],
        filters: {
          newsname: '',
          beginDate:'',
          endDate:'',
          pubstate:'1',
          consultId:'',
          projectId:'',
          newsTypeId:'',
          sub1:'',
          sub2:''
        },
        checkAll: true,
        isIndeterminate: false,
        projtypess : [{"name":"继续医学教育","id":1},{"name":"基层卫生人员培训","id":2},{"name":"三基培训","id":3},{"name":"全员/专项培训","id":4},{"name":"执业资格考试","id":5},{"name":"医师定考","id":6},{"name":"住院医师规范化培训","id":7},{"name":"云南基层大练兵","id":8},{"name":"贵州基层大练兵","id":9}],
        news: [],
        total: 0,
        pageSize:10,
        page: 1,
        addFormTtile:'',
        currentPage:1,
        listLoading: false,
        sels: [],//列表选中列
        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        ckUploadUrl:process.env.VUE_APP_API_URL_WX+"/api/common/ckImgFileUpload?command=QuickUpload&type=Images",
        jplusUpload:process.env.VUE_APP_API_URL_WX+"/api/common/jplusUpload",
        uploadUrl:process.env.VUE_APP_API_URL_WX+"/api/wechat/file/ImgFileUpload",
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          newsTitle: [
            { required: true, validator: validateNITitle,trigger: 'blur' }
          ],
          newsSource: [
            { required: true, message: '请输入文章来源', trigger: 'blur' }
          ],
          keywords: [
            { required: true, message: '请输入关键词', trigger: 'blur' }
          ],
          description: [
            { required: true, message: '请输入描述', trigger: 'blur' }
          ]
        },
        //新增界面数据
        addForm: {
          id:'',
          oldName:'',
          consultId: '',
          consultReturn:[],
          sId1:'',
          sId1Return:[],
          sId2:'',
          sId2Return:[],
          project:[],
          newsTitle:'',
          newsTypeId:'',
          newsTypeReturn:'',
          author:'',
          authorId:'',
          editor:'',
          newsSource:'',
          publishTime:'',
          keywords:'',
          description:'',
          fileList:[],
          displayPosition:'',
          isNew:'',
          declareType:'',
          content:'',
          subjectArray:[],
          subjects:'',
          imgUrl:'',
          weight:'',
          checkAll:true,
          isIndeterminate: true,
          secondLoginId:[],
          secondLoginOptions:[],
        },
        selectLoading: false,
        selectOptions: []
      }
    },
    methods: {
      /**
     * @description: 专家远程搜索
     */
    remoteMethod(name) {
      if (name !== "") {
        this.nativepageSearch(name)
      } else {
        this.selectOptions = [];
      }
    },
    /**
     * @description: 模糊搜索专家
     */
    nativepageSearch(name){
      this.selectLoading = true;
      let params = {}
      if (name) {
        params.doctorName = name
      }
      doctorSearchDoctor(params).then(res => {
        this.selectLoading = false;
        if (res.code !== 0) {
          this.$message.error(res.msg)
          this.selectOptions = [];
          return
        }
        this.selectOptions = res.data;
      }).catch(() => {
        this.selectLoading = false;
        this.selectOptions = [];
      })
    },
      formatpstate: (row)=> {
        return row.publishState == 0 ? '已发布' : row.publishState == 1 ? '未发布' : row.publishState ==2 ? '删除' : '草稿';
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getNews();
      },

      //发布资讯
      publisNew(index, row){
        this.$confirm('确认发布资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 0);
          delNewsInfo(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getNews()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      //取消发布资讯
      cancelPublish(index, row){
        this.$confirm('确认取消发布资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 1);
          delNewsInfo(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getNews()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      viewNews(index, row){
        window.open(process.env.VUE_APP_YIBOSHI_URL+"newsInfo?id="+row.id);
      },
      uploadBefore(file) {
        if (file.size > 200*1024) {
          this.$message.error('图标大小不能超过200kb, 请重新上传!')
          return false
        }
      },
      handleSuccess(response){
        this.addForm.imgUrl=response.data.imgUrl
      },

      //获取用户列表
      getNews() {
        const formData = new FormData();
        formData.append('pageNum', this.currentPage);
        formData.append('pageSize', this.pageSize);
        formData.append('newsname', this.filters.newsname);

        formData.append('startCal', (! this.filters.beginDate ||  this.filters.beginDate == '') ? '' : util.formatDate.format(new Date( this.filters.beginDate), 'yyyy-MM-dd'));
        formData.append('endCal', (! this.filters.endDate ||  this.filters.endDate == '') ? '' : util.formatDate.format(new Date( this.filters.endDate), 'yyyy-MM-dd'));

        formData.append('consultId', this.filters.consultId);
        formData.append('pId', this.filters.projectId);
        formData.append('sId1', this.filters.sub1);
        formData.append('sId2', this.filters.sub2);
        formData.append('nId', this.filters.newsTypeId);
        formData.append('publishState', this.filters.pubstate);

        this.listLoading = true;
        getNewsListPage(formData).then((res) => {
          this.total = res.data.data.total;
          this.news = res.data.data.list;
          this.listLoading = false;
        });
      },
      /*查询资讯分类*/
      getConsult(){
          const form = new FormData();
          form.append('dataAccess', true);
          getConsultList(form).then((response)=> {
              this.addForm.consultReturn = response.data.data;
          })
      },
      getSecondLoginPosition(){
        getSecondLoginPosition().then((response)=> {
          this.addForm.secondLoginOptions = response.data.data;
        })
      },
      /*/!*查询项目分类*!/
      getDictProject(){
        getDictProject().then((response) => {
          this.addForm.project = response.data.data;
        }).catch((error) =>{
        })
      },*/

      /*查询文章类型*/
        getDictNewsType(){
          getDictNewsType().then((response) => {
            this.addForm.newsTypeReturn = response.data.data;
        })
      },

    /*查询学科分类*/
      getDictSubject(){
        const formData = new FormData();
        formData.append('sId1', "");
        getDictSubject(formData).then((response)=> {
            this.addForm.sId1Return = response.data.data;
        })
      },

      /*查询学科分类2*/
      getDictSubject2(){
        const formData = new FormData();
        if(this.filters.sub1 !=null && this.filters.sub1 !=""){
          formData.append('sId1', this.filters.sub1);
        }else{
          formData.append('sId1', this.addForm.sId1);
        }
        getDictSubject(formData).then((response) =>{
          this.addForm.sId2Return = response.data.data;
        })
      },

      addSubject(){
       if(this.addForm.sId1 !="" && this.addForm.sId2 ==""){
          this.$message({
            type: 'info',
            message: '请选择学科分类2'
          });
        }else if(this.addForm.sId1 !="" || this.addForm.sId2 !=""){
          //获取分类1名称
          let lable1="";
          for(let item in this.addForm.sId1Return){
            if(this.addForm.sId1Return[item].id == this.addForm.sId1){
              lable1=this.addForm.sId1Return[item].name;
            }
          }
          //获取分类2名称
          let lable2="";
          for(let item in this.addForm.sId2Return){
            if(this.addForm.sId2Return[item].id == this.addForm.sId2){
              lable2=this.addForm.sId2Return[item].name;
            }
          }

          if(this.addForm.sId1 == "0" && this.addForm.sId2 =="0" ){
            if(this.addForm.subjects !=null && this.addForm.subjects !=""){
              this.$message({
                type: 'info',
                message: '学科已选择，请勿再选择全部！'
              });
            }else {
              this.addForm.subjects+=";"+this.addForm.sId1+","+this.addForm.sId2+";";
              let map={key : this.addForm.sId1+","+this.addForm.sId2,value: lable1+"---"+lable2};
              this.addForm.subjectArray.push(map);
            }
          }else if(this.addForm.sId1 != "0" && this.addForm.sId2 !="0" ){
            if(this.addForm.subjects.indexOf(this.addForm.sId1+","+this.addForm.sId2+";") >= 0 ){
              this.$message({
                type: 'info',
                message: '学科已选择，请勿重复选择！'
              });
            }else if(this.addForm.subjects.indexOf(this.addForm.sId1+","+"0;") >= 0){
              this.$message({
                type: 'info',
                message: '当前一级学科分类已经选择全部！'
              });
            }else if(this.addForm.subjects.indexOf(";0,0;") >= 0){
              this.$message({
                type: 'info',
                message: '当前学科分类已经选择全部！请勿再选择！'
              });
            }else{
              this.addForm.subjects+=this.addForm.sId1+","+this.addForm.sId2+";";
              let map={key : this.addForm.sId1+","+this.addForm.sId2,value: lable1+"---"+lable2};
              this.addForm.subjectArray.push(map);
            }
          }else if(this.addForm.sId1 != "0" && this.addForm.sId2 =="0"){

            if(this.addForm.subjects.indexOf(this.addForm.sId1+","+"0;") >= 0 ){
              this.$message({
                type: 'info',
                message: '当前一级学科分类已经选择全部！'
              });
            }else if(this.addForm.subjects.indexOf(this.addForm.sId1+",") >= 0){
              this.$message({
                type: 'info',
                message: '已添加当前学科分类二级学科，请先取消已添加二级学科！'
              });
            }else if(this.addForm.subjects.indexOf(";0,0;") >= 0){
              this.$message({
                type: 'info',
                message: '当前学科分类已经选择全部！请勿再选择！'
              });
            }else{
              this.addForm.subjects+=this.addForm.sId1+","+this.addForm.sId2+";";
              let map={key : this.addForm.sId1+","+this.addForm.sId2,value: lable1+"---"+lable2};
              this.addForm.subjectArray.push(map);
            }
          }
        }else{
          this.$message({
            type: 'info',
            message: '请选择学科分类'
          });
        }
      },

      removeSubject(item){
        this.addForm.subjects=this.addForm.subjects.replace(item.key+";","");
        for(let i in this.addForm.subjectArray){
          if(this.addForm.subjectArray[i].key == item.key){
            this.addForm.subjectArray.splice(i,1);
          }
        }
      },

      //显示编辑界面
      handleEdit(index, row) {
        this.addFormTtile="修改";
        this.getConsult();
        this.getDictNewsType();
        this.getDictSubject();
        this.addFormVisible = true;
        this.addForm.id=row.id;
        this.addForm.oldName=row.newsTitle;
        this.addForm.newsTitle=row.newsTitle;
        this.addForm.author=row.author;
        if (row.author) {
          this.nativepageSearch(row.author)
        }
        this.addForm.authorId=row.authorId > 0 ? row.authorId : '';
        this.addForm.editor=row.editor;
        this.addForm.newsSource=row.newsSource;
        this.addForm.publishTime=this.$dayjs(row.publishTime).format();
        this.addForm.keywords=row.keywords;
        this.addForm.description=row.description;
        this.addForm.imgUrl=row.image;
        this.addForm.fileList = row.image?[{url: row.image}]:[];
        this.addForm.displayPosition=row.displayPositionId+"";
        this.addForm.declareType=row.declareType+"";
        this.addForm.isNew=row.isNew+"";
        this.addForm.weight=row.weight;
        this.addForm.consultId=row.consultId;
        this.addForm.newsTypeId=row.newstypeId;
        this.addForm.content=row.content;
        if(row.projectIntIds ==null || row.projectIntIds ==""){
          this.addForm.project=[];
        }else{
          this.addForm.project=row.projectIntIds;
        }
        this.addForm.subjects = row.tagIds;
        this.addForm.subjectArray = row.subListArr;
        this.addForm.secondLoginId = row.secondLoginId?row.secondLoginId.split(","):[];
      },


      handleDel(index, row) {//删除产品
        this.$confirm('确认要删除该资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', 2);
          delNewsInfo(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$message({
                type: 'success',
                message: data.msg
              });
              this.getNews()
            } else {
              this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //显示新增界面
      handleAdd: function () {

        this.addFormTtile="新增";
        this.addFormVisible = true;

        this.addForm.id='';
        this.addForm.newsTitle='';
        this.addForm.author='';
        this.addForm.authorId='';
        this.addForm.editor=''
        this.addForm.newsSource='';
        this.addForm.publishTime='';
        this.addForm.keywords='';
        this.addForm.description='';
        this.addForm.imgUrl='';
        this.addForm.fileList = [];
        this.addForm.displayPosition='3';
        this.addForm.declareType='2';
        this.addForm.isNew='1';
        this.addForm.weight='';
        this.addForm.consultId='';
        this.addForm.newsTypeId=1;
        this.addForm.content='';
        this.addForm.project=[1,2,3,4,5,6,7,8,9];
        this.addForm.sId1='';
        this.addForm.sId2='';
        this.addForm.subjectArray=[];
        this.addForm.subjects='';
        this.addForm.secondLoginId=[];

        this.selectOptions=[];

      },
      handleCheckAllChange(event) {
        this.addForm.project = event ? [1,2,3,4,5,6,7,8,9] : [];
        this.addForm.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.addForm.checkAll = checkedCount === [1,2,3,4,5,6,7,8,9].length;
        this.addForm.isIndeterminate = checkedCount > 0 && checkedCount < [1,2,3,4,5,6,7,8,9].length;
      },
      //新增
      addSubmit(type) {
        if(this.addForm.consultId==24 && this.addForm.secondLoginId.length==0) {
          this.$message({
            type: 'warning',
            message: '请选择要推送到的二级模板页'
          });
        }else{
          this.$refs.addForm.validate((valid) => {
            if (valid) {
              this.$confirm('确认提交吗？', '提示', {}).then(() => {

                this.addLoading = true;
                const formData = new FormData();
                formData.append('consultId', this.addForm.consultId);
                formData.append('publishState', type);
                formData.append('projectIds', this.addForm.project);
                formData.append('newsTitle', this.addForm.newsTitle);
                formData.append('newstypeId', this.addForm.newsTypeId);
                // if(this.addForm.author!=null && typeof(this.addForm.author)!="undefined" && this.addForm.author!="undefined"){
                //   formData.append('author', this.addForm.author);
                // }else{
                //   formData.append('author', "");
                // }
                if (this.addForm.authorId && this.addForm.authorId > 0) {
                  const getAuthorName = () => {
                    let name = ''
                    this.selectOptions.forEach(e => {
                      if (e.doctorId === this.addForm.authorId) {
                        name = e.doctorName
                      }
                    });
                    return name
                  }
                  formData.append('authorId', this.addForm.authorId);
                  formData.append('author', getAuthorName());
                } else {
                  formData.append('authorId', '');
                  formData.append('author', '');
                }

                if(this.addForm.editor!=null && typeof(this.addForm.editor)!="undefined" && this.addForm.editor!="undefined"){
                    formData.append('editor', this.addForm.editor);
                }else{
                    formData.append('editor', "");
                }
                formData.append('newsSource', this.addForm.newsSource);
                formData.append('publishTime', (! this.addForm.publishTime ||  this.addForm.publishTime == '') ? '' : this.$dayjs(this.addForm.publishTime).format("YYYY-MM-DD HH:mm:ss"));
                formData.append('keywords', this.addForm.keywords);
                formData.append('description', this.addForm.description);
                if(this.addForm.imgUrl!=null && typeof(this.addForm.imgUrl)!="undefined" && this.addForm.imgUrl!="undefined"){
                    formData.append('image', this.addForm.imgUrl);
                }else{
                    formData.append('image', "");
                }
                formData.append('displayPosition', this.addForm.displayPosition);
                if(this.addForm.isNew!=null && typeof(this.addForm.isNew)!="undefined" && this.addForm.isNew!=""){
                    formData.append('isNew', this.addForm.isNew);
                }else{
                    formData.append('isNew', 0);
                }
                if(this.addForm.declareType!=null && typeof(this.addForm.declareType)!="undefined" && this.addForm.declareType!="" && this.addForm.declareType!=0){
                    formData.append('declareType', this.addForm.declareType);
                }else{
                    formData.append('declareType', 2);
                }
                formData.append('content', this.addForm.content);
                formData.append('subjects', this.addForm.subjects);
                if(this.addForm.weight!=null && typeof(this.addForm.weight)!="undefined" && this.addForm.weight!=""){
                    formData.append('weight', this.addForm.weight);
                }else{
                    formData.append('weight', 0);
                }
                formData.append('secondLoginId', this.addForm.secondLoginId);
                if(this.addForm.id !=null && this.addForm.id !=""){ //修改
                  formData.append('id', this.addForm.id);
                  editNewsInfo(formData).then((res) => {
                    this.addLoading = false;
                    if(res.data.status == 200){
                      this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                      });
                      this.$refs['addForm'].resetFields();
                      this.addFormVisible = false;
                      this.getNews();
                    }else{
                      this.$notify({
                        title: '失败',
                        message: '修改失败',
                        type: 'fail'
                      });
                    }
                  }).catch(() => {
                    this.addLoading = false;
                  });
                }else{
                  addNewsInfo(formData).then((res) => {  //添加
                    this.addLoading = false;
                    if(res.data.status == 200){
                      this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                      });
                      this.$refs['addForm'].resetFields();
                      this.addFormVisible = false;
                      this.getNews();
                    }else{
                      this.$notify({
                        title: '失败',
                        message: '添加失败',
                        type: 'fail'
                      });
                    }
                  }).catch(() => {
                    this.addLoading = false;
                  });
                }
              });
            }
          });
        }
      },
      selsChange: function (sels) {
        this.sels = sels;
      },
    },
    mounted() {
      this.getNews();
      this.getConsult();
      this.getDictNewsType();
      this.getDictSubject();
      this.getSecondLoginPosition();
    }
  }
</script>

<style>

.custom_select .el-select-dropdown__item{
  height: auto;
}
.custom_select .el-select-dropdown__item .custom_content{
  padding: 10px 0;
}
.custom_select .el-select-dropdown__item .custom_content >p:nth-child(1){
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 8px !important;
}
.custom_select .el-select-dropdown__item .custom_content >p:nth-child(2){
  margin-bottom: 5px !important;
}
.custom_select .el-select-dropdown__item .custom_content >p:nth-child(2), .custom_select .el-select-dropdown__item .custom_content >p:nth-child(3){
  color: #8492a6;
  font-size: 12px;
  line-height: 12px;
}
</style>
